import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDatabase } from '../hooks/useDatabase';
import { usePublicLanding } from '../hooks/usePublicContent';
import { ThankYouView } from '../components/public/ThankYouView';
import { ThankYouConfig } from '../types';
const FALLBACK: ThankYouConfig = {
  title: 'Hemos recibido tu solicitud.',
  text: 'Nuestro equipo se pondrá en contacto contigo lo antes posible.',
  showCalendly: false,
  showWhatsapp: false,
  showHome: true
};

/** Página de agradecimiento configurable por landing: /gracias/:slug */
export function ThankYou() {
  const {
    slug = ''
  } = useParams();
  const db = useDatabase();
  usePublicLanding(slug);
  const landing = db.landings.find(l => l.slug === slug);
  const organization = landing ? db.organizations.find(o => o.id === landing.organizationId) : undefined;
  const logoUrl = landing?.pageConfig.logoUrl ?? organization?.brand.logoUrl ?? organization?.logoUrl;
  const config = landing?.pageConfig.thankYou ?? FALLBACK;
  useEffect(() => {
    if (!config.autoRedirectUrl) return;
    const timer = setTimeout(() => {
      window.location.href = config.autoRedirectUrl as string;
    }, 4000);
    return () => clearTimeout(timer);
  }, [config.autoRedirectUrl]);
  return <ThankYouView config={config} logoUrl={logoUrl} primaryColor={landing?.pageConfig.primaryColor} data-id="element-1839" data-mp="1u64qyegfrqm0" />;
}